import React from "react";
import { useEntidade } from "../Hooks/EntidadeHook";

import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { app_base_url } from "../Utils/Urls";
import { Home } from "../Pages/Home";
import { SignIn } from "../Pages/Login";

import { Header } from "../Components/Header";
import { useUsuario } from "../Hooks/UsuarioHook";
import { EmpresaPage } from "../Pages/Empresa";
import { useUsuarioPrefeitura } from "../Hooks/UsuarioPrefeituraHook";
import { VisualizacaoGeral } from "../Pages/VisualizacaoGeral";
import { SeletorProvider } from "../Storage/seletor";
import { Menu } from "../Components/Menu";
import { LoginNaoEmitoNotaFiscal } from "../Pages/Login/LoginNaoEmitoNotaFiscal";
import { useUsuarioNaoEmiteNota } from "../Hooks/UsuarioNaoEmiteNotaHook";
import { LoginUsuarioPrefeitura } from "../Pages/Login/LoginUsuarioPrefeitura";
import { BancoPrefeituraGuard } from "./BancoPrefeituraGuard";
export const Rotas = () => {
  const { usuario } = useUsuario();
  const { usuarioNaoEmiteNota } = useUsuarioNaoEmiteNota();
  const { usuarioPrefeitura } = useUsuarioPrefeitura();
  return (
    <Router>
      
      {usuario.CPF || usuarioPrefeitura.usuario || usuarioNaoEmiteNota.CODIGO ? (
        <>

          {(usuario.CPF || usuarioPrefeitura.usuario) && <><Header /> <Menu />
          
              <Routes>
                <Route
                  path={`${app_base_url}/:banco/firma/:id`}
                  element={<EmpresaPage />}
                ></Route>
                <Route
                  path={`${app_base_url}/:banco/geral`}
                  element={<VisualizacaoGeral />}
                ></Route>

                <Route path={`${app_base_url}/:banco/*`} element={<Home />}></Route>

              </Routes></>}


          {usuarioNaoEmiteNota.CODIGO && <Routes>
            <Route path={`${app_base_url}/:banco/*`} element={<EmpresaPage />}></Route>
          </Routes>}


        </>
      ) : (
          <BancoPrefeituraGuard>
        <Routes>
          <Route path={`${app_base_url}/:banco/nao-emito-nota-fiscal`} element={<LoginNaoEmitoNotaFiscal />}></Route>
          <Route
            path={`${app_base_url}/:banco/prefeitura`}
            element={<LoginUsuarioPrefeitura />}
          ></Route>

          <Route path={`/*`} element={<SignIn />}></Route>

        </Routes>
        </BancoPrefeituraGuard>
      )}
    </Router>
  );
};
